import BA from "country-flag-icons/react/3x2/BA";
import HR from "country-flag-icons/react/3x2/HR";
import RS from "country-flag-icons/react/3x2/RS";
import GB from "country-flag-icons/react/3x2/GB";
import DE from "country-flag-icons/react/3x2/DE";

const FLAGS = {
	BA: BA,
	HR: HR,
	SR: RS,
	EN: GB,
	DE: DE,
};

export default function FlagIcon({ code }) {
	const Flag = FLAGS[code];
	return Flag ? <Flag /> : null;
}
